export const MIN_NAME_INPUT_LENGTH = 1;

/*
 * Maximum name and description lengths must match whatever value is there in jira monolith repository in class
 * com.atlassian.jira.simplified.issuetype.SimplifiedIssueTypeValidator
 */
export const MAX_NAME_INPUT_LENGTH = 60;
export const MAX_DESCRIPTION_INPUT_LENGTH = 255;

// This is the default max length for JSM request type help text as seen in the Portal.
export const MAX_HELPTEXT_INPUT_LENGTH = 1000;
